import yn from "yn";

const { VITE_AI_SKILLS_ENABLED } = import.meta.env;

/**
 * Feature flag hook for AI Skills functionality.
 *
 * Controls whether users see:
 * - RichTextInput with /skill blocks (enabled) vs plain textarea (disabled)
 * - SkillSelector dropdown (enabled) vs hidden (disabled)
 * - SkillAutocomplete popup (enabled) vs hidden (disabled)
 *
 * Requires both:
 * - VITE_AI_SKILLS_ENABLED environment variable must be true
 *
 * @returns true if skills feature is enabled for the current environment, false otherwise
 */
export function useSkillsFeature(): boolean {
  if (!yn(VITE_AI_SKILLS_ENABLED, { default: true })) {
    return false;
  }

  return true;
}
